// extracted by mini-css-extract-plugin
export default {"backTo":"backTo___ZCBSw","linkButton":"linkButton___T1yqo","errorBody":"errorBody___rv08b"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"backTo\":\"backTo___ZCBSw\",\"linkButton\":\"linkButton___T1yqo\",\"errorBody\":\"errorBody___rv08b\"}";
        // 1793018520129
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  